// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "portal/static/css/" + chunkId + "." + {"2872":"3171f14a","8634":"12cbc4ca"}[chunkId] + ".chunk.css";
};